import React, { useState, useEffect, useContext } from "react"
import { Grid } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import Button from "@material-ui/core/Button"
import { ItemContext } from "../../ComponentLoader"
import ComponentThumbnail from "../../ComponentThumbnail"
import Card from "@material-ui/core/Card"
import CardActions from "@material-ui/core/CardActions"
import CardContent from "@material-ui/core/CardContent"
import CardHeader from "@material-ui/core/CardHeader"
import Typography from "@material-ui/core/Typography"
import TextField from "@material-ui/core/TextField"
import InputAdornment from "@material-ui/core/InputAdornment"
import Select from "@material-ui/core/Select"
import InputLabel from "@material-ui/core/InputLabel"
import MenuItem from "@material-ui/core/MenuItem"
import FormHelperText from "@material-ui/core/FormHelperText"
import FormControl from "@material-ui/core/FormControl"
import CustomAlert from "../../../tourManagerComponents/CustomAlert"

const useStyles = makeStyles((theme) => ({
  textInput: {
    marginRight: theme.spacing(1),
    width: "10ch",
  },
}))

export default function TextInputScreenSettings({ setShowTransition }) {
  const classes = useStyles()
  const itemContext = useContext(ItemContext)
  const {
    item,
    previewMode,
    siblings,
    updateItem,
    openTourSectionManager,
    handleAssetsViewerOpen,
  } = itemContext

  const [width, setWidth] = useState(
    item.data.advancedSettings.textInputSettings.width
  )
  const [height, setHeight] = useState(
    item.data.advancedSettings.textInputSettings.height
  )
  const [top, setTop] = useState(
    item.data.advancedSettings.textInputSettings.top
  )
  const [left, setLeft] = useState(
    item.data.advancedSettings.textInputSettings.left
  )
  const [backgroundColor, setBackgroundColor] = useState(
    item.data.advancedSettings.textInputSettings.backgroundColor
  )

  const handleWidthChange = (event) => {
    if (event.target.value <= 100 && event.target.value >= 0) {
      setWidth(event.target.value)
      item.data.advancedSettings.textInputSettings.width = event.target.value
      item.data.advancedSettings.textInputSettings.showTransition = true
      updateItem(item)

      handleTransition()
    }
  }

  const handleHeightChange = (event) => {
    if (event.target.value <= 100 && event.target.value >= 0) {
      setHeight(event.target.value)
      item.data.advancedSettings.textInputSettings.height = event.target.value
      item.data.advancedSettings.textInputSettings.showTransition = true
      updateItem(item)

      handleTransition()
    }
  }

  const handleTopChange = (event) => {
    if (event.target.value <= 100 && event.target.value >= 0) {
      setTop(event.target.value)

      item.data.advancedSettings.textInputSettings.top = event.target.value

      item.data.advancedSettings.textInputSettings.showTransition = true
      updateItem(item)

      handleTransition()
    }
  }

  const handleLeftChange = (event) => {
    if (event.target.value <= 100 && event.target.value >= 0) {
      setLeft(event.target.value)

      item.data.advancedSettings.textInputSettings.left = event.target.value

      item.data.advancedSettings.textInputSettings.showTransition = true
      updateItem(item)

      handleTransition()
    }
  }

  const handleTransition = () => {
    function transition() {
      item.data.advancedSettings.textInputSettings.showTransition = false
      updateItem(item)
    }
    clearTimeout(transition)
    window.setTimeout(transition, 300)
  }

  const handleBackgroundColorChange = (event) => {
    setBackgroundColor(event.target.value)
    item.data.advancedSettings.textInputSettings.backgroundColor =
      event.target.value
    updateItem(item)
  }

  return (
    <Grid container>
      <Grid item>
        <Typography variant="h4" component="h2" style={{ paddingTop: 15 }}>
          Text Input Settings
        </Typography>
        <CustomAlert
          heading={"Info"}
          text={
            "Each of these values are processed as percentages of the available device screen space"
          }
          severity={"info"}
        />
        <TextField
          id="text-input-width"
          label="
          Width"
          value={width}
          type="number"
          inputProps={{
            min: 0,
            max: 100,
          }}
          onChange={handleWidthChange}
          variant="outlined"
          margin="normal"
          className={classes.textInput}
        />
        <TextField
          id="text-input-height"
          label="Height"
          value={height}
          type="number"
          inputProps={{ min: 0, max: 100 }}
          onChange={handleHeightChange}
          variant="outlined"
          margin="normal"
          className={classes.textInput}
        />
        <TextField
          id="text-input-top"
          label={item.data.orientation === "Landscape" ? "Left" : "Top"}
          value={top}
          type="number"
          inputProps={{ min: 0, max: 100 }}
          onChange={handleTopChange}
          variant="outlined"
          margin="normal"
          className={classes.textInput}
        />
        <TextField
          id="text-input-Left"
          label={item.data.orientation === "Landscape" ? "Top" : "Left"}
          value={left}
          type="number"
          inputProps={{ min: 0, max: 100 }}
          onChange={handleLeftChange}
          variant="outlined"
          margin="normal"
          className={classes.textInput}
        />

        <FormControl variant="outlined" margin="normal">
          <InputLabel id="text-input-backgroundColor">
            Background Color
          </InputLabel>
          <Select
            labelId="text-input-backgroundColor-label"
            id="text-input-backgroundColor"
            value={backgroundColor}
            onChange={handleBackgroundColorChange}
            label="Background Color"
          >
            <MenuItem value={"transparent"}>Transparent</MenuItem>
            <MenuItem value={"#fff"}>White</MenuItem>
            <MenuItem value={"#eee"}>Light Grey</MenuItem>
          </Select>
        </FormControl>
      </Grid>
    </Grid>
  )
}
